<template>
  <section>
    <div
      class="aggregator"
      v-for="widget in orders"
      v-bind:key="widget.name"
    >
      <button
        type="button"
        class="aggregator__header"
        v-on:click="onShowOrders(widget)"
      >
        <span class="aggregator__title">
          {{ widget.name }}
          <span
            title="Количество заявок"
            class="aggregator__total"
            v-bind:class="{ color: widget.total === 0 }"
          >
            ({{ widget.total }})
          </span>
        </span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    /**
     * @description Обработать показ заявок от агрегатора.
     * @param {object} widget
     * @returns {void}
     */
    onShowOrders(widget) {
      this.$emit('open-orders', widget);
    },
  },
  props: {
    /**
     * @description Заявки на прием.
     * @type {any[]}
     */
    orders: { type: Array, required: true },
  },
};
</script>

<style scoped lang="scss">
.aggregator {
  &__header {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;
  }
  &__num-orders {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #0489E0;
    border-radius: 50%;
    color: #0489E0;
    height: 25px;
    width: 25px;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
  }
  &__title {
    font-weight: 400;
    font-size: 12px !important;
    line-height: 14px !important;
    cursor: pointer;
    color: #0489e0;
    border-bottom: 1px solid rgba(4, 137, 224, .3);
    &:hover {
      border-bottom: 1px solid transparent;
    }
  }
  &__total {
    color: red;
    &.color {
      color: #0489e0;
    }
  }
  &__title ~ &__num-orders {
    margin-left: 0.3rem;
  }
}
</style>
